import { useEffect, useState } from 'react';
import { Layout, Modal, Row, Col, Form, Input, Button, Checkbox, Typography, Divider, Select, message } from 'antd';
import { CheckCircleTwoTone } from '@ant-design/icons'; 
import { useHistory } from 'react-router-dom';
var Airtable = require('airtable');

const axios = require('axios');
const { Title, Text } = Typography;
const { Option, OptGroup } = Select;

const API_KEY = `keyDK80FJl78M2lJg`;

const UpdateDetails = ({ 
    showUpdateModal, setUpdateModal
}) => {

    const history = useHistory();
    const routeChange = (url) => {
      history.push(url);
    };

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [email, setEmail] = useState(null);
    const [submit, setSubmit] = useState(false); 

    const airtableURL = `https://api.airtable.com/v0/appK2OtTAUAdItovV/Main?api_key=${API_KEY}`
 
 
    const onFinish = (values) => { 

        setError(false);        
        setLoading(true); 
        axios.get(`https://api.airtable.com/v0/appK2OtTAUAdItovV/Main?fields[]=Email&filterByFormula=SEARCH("${values.email}",Email)&api_key=${API_KEY}`).then(function (response) {
            

            var base = new Airtable({apiKey: API_KEY}).base('appK2OtTAUAdItovV');

            base('Main').update( response?.data?.records[0].id,{
                "Email": values.email,
                "City": values.city,
                "Mobile": values.mobile,
                "Pincode": values.pincode
            }, function(err, record) {
              if (err) {
                console.error(err);
                setSubmit(false);
                return;
              } 
              setLoading(false);
              setSubmit(true);
            });

            
           
        })
        .catch(function (error) { 
            console.log('form submission error-->', error); 
            setLoading(false);
            setError(true);
        });

        
     

    };

    const onFinishFailed = (errorInfo) => {
        // console.log('Failed:', errorInfo);
    };

 
  return (
      <div className={'update-details-wrapper'}>

      
    <Modal style={{ top: 20 }}  
    footer={null} 
    visible={true }
    centered
    maskClosable={false}
    onCancel={()=>routeChange('/')} 
    >

      <Row>
        <Col lg={24}>
        <div className={'form-wrapper'}>
                <Form

                    name="notification-form"
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    disabled={submit}
                >
                    {!submit && <> 
                        <Title style={{ marginTop: '5px' }} className={'mb-2 mt-0 text-grey-1 text-center'} level={4}>{`Signed up earlier?`}</Title>
                        <Title style={{ marginTop: '5px' }} className={'mb-2 mt-0 text-grey-1 text-center'} level={4}>{`Use this form to add details to your account`}</Title>
                     
                                <Form.Item
                                    name="email"
                                    rules={[{ required: true, type: 'email', message: 'Please enter your Email' }]}
                                >
                                    <Input className={''} size={'large'} placeholder={'Email'} disabled={loading || submit} />
                                </Form.Item>
                                <Form.Item
                                    name="pincode"  
                                >
                                    <Input className={''} size={'large'} placeholder={'Pincode'} disabled={loading || submit} />
                                </Form.Item>
                                <Form.Item
                                    name="mobile" 
                                >
                                    <Input className={''} size={'large'} placeholder={'Mobile (10 Digits)'} disabled={loading || submit} />
                                </Form.Item>


                                <Form.Item>
                                    <Button size={'large'} className={'w-full cta-btn mt-4'} type="primary" htmlType="submit" loading={loading} disabled={submit}>
                                        UPDATE DETAILS
      </Button>
                                </Form.Item> 

                    </>}

                    {submit && <div className={'mt-10 flex items-center flex-col'}>
                        <CheckCircleTwoTone twoToneColor="#52c41a" style={{ fontSize: '36px' }} />
                        <Title style={{ marginBottom: '12px' }} className={'mt-4 mb-0 text-grey-1 text-center'} level={3}>Thank you!</Title>
                        <Title style={{ marginTop: '6px' }} className={'mb-2 mt-0 text-grey-1 text-center'} level={4}>{`Your details have been updated! `}</Title>
                    </div>} 
                    { error && <div className={'mt-4 w-full flex justify-center flex-col items-center'}>
                    <Text type="danger" className={'text-center'}>Oops, seems like you haven’t signed up yet!</Text>
                    <Button  className={'mt-4 text-center'} onClick={()=>routeChange('/')} >Click here to Sign Up</Button>
                    </div>
                    }
                </Form>
            </div>
          </Col>

      </Row>
    </Modal>
    </div>
  )
}


export default UpdateDetails